import {
  TeamsMeetingFields,
  TeamsMeetingFields_invitees_edges_node,
  TeamsMeetingFields_moderators_edges_node,
  TeamsMeetingFields_organizers_edges_node,
} from '@ms/yammer-graphql';

import { TeamsMeeting } from '../../../state/types';
import { Override } from '../../types';

import { getNodesFromEdges } from './edges';

export type ReferenceTypeSchemaMapping = typeof referenceTypeSchemaMapping;
const referenceTypeSchemaMapping = {
  User: 'users',
  OfficeGroup: 'officeGroups',
} as const;

interface TeamsMeetingInviteeOverrides {
  readonly __typename: ReferenceTypeSchemaMapping[keyof ReferenceTypeSchemaMapping];
}

type PrenormalizedTeamsMeetingInvitee = Override<TeamsMeetingFields_invitees_edges_node, TeamsMeetingInviteeOverrides>;
type TransformTeamsMeetingInvitee = (
  invitee: TeamsMeetingFields_invitees_edges_node
) => PrenormalizedTeamsMeetingInvitee;
const transformTeamsMeetingInvitee: TransformTeamsMeetingInvitee = ({ __typename, ...invitee }) => ({
  __typename: referenceTypeSchemaMapping[__typename],
  ...invitee,
});

export interface TeamsMeetingOverrides {
  readonly invitees: PrenormalizedTeamsMeetingInvitee[];
  readonly moderators: TeamsMeetingFields_moderators_edges_node[];
  readonly organizers: TeamsMeetingFields_organizers_edges_node[];
}

type PrenormalizedTeamsMeeting = Override<TeamsMeeting, TeamsMeetingOverrides>;
type ProcessTeamsMeeting = (value: TeamsMeetingFields) => PrenormalizedTeamsMeeting;
export const processTeamsMeeting: ProcessTeamsMeeting = (value) => ({
  ...value,
  startAt: new Date(value.startAt).getTime(),
  endAt: new Date(value.endAt).getTime(),
  creator: value.creator?.id,
  organizers: getNodesFromEdges(value.organizers.edges),
  moderators: getNodesFromEdges(value.moderators.edges),
  invitees: getNodesFromEdges(value.invitees.edges).map(transformTeamsMeetingInvitee),
});
